import React, { useState } from 'react'
import { ThemeProvider } from 'styled-components'
import VideoModal from '../components/VideoModal/VideoModal'
import ClubBanner from '../components/ClubBanner/ClubBanner'
import HowItWorks from '../components/HowItWorks/HowItWorks'
import KitPreview from '../components/KitPreview/KitPreview'
import PreviousKits from '../components/PreviousKits/PreviousKits'
import NextKit from '../components/NextKit/NextKit'
import TAGTopics from '../components/TAGTopics/TAGTopics'
import ClubSubscription from '../components/ClubSubscription/ClubSubscription'
import ClubTest from '../components/ClubTest/ClubTest'
import Newsletter from '../components/Newsletter/Newsletter'
import Footer from '../components/Footer/Footer'
import { clubBannerCuradoriaData } from '../components/ClubBanner/ClubBannerData'
import { howItWorksCuradoriaDefaultData } from '../components/HowItWorks/HowItWorksData'
import { kitPreviewCuradoriaData } from '../components/KitPreview/KitPreviewData'
import { nextCuradoriaData } from '../components/NextKit/NextKitData'
import { curadoriaTopicsData } from '../components/TAGTopics/TAGTopicsData'
import { clubCuradoriaData } from '../components/ClubSubscription/ClubSubscriptionData'
import useChatbot from '../helpers/useChatbot'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'

const curadoriaTheme = {
  'bannerBackgroundColor': '#e6ccbd',
  'clubMainColor': '#009bbf',
  'clubSecondaryColor': '#00c2e2',
  'howItWorksSubtitleLineHeight': '1.8',
  'howItWorksTitleMaxWidth': '250px',
  'largeSelector': true,
  'planSelectorBackgroundColor': '#16b9df',
  'planSelectorUncheckedButtonColor': '#96a0c0',
  'topicsBackgroundColor': '#141e3e',
  'topicsNumberColor': '#4b64b1',
}

const Curadoria = ( { data } ) => {
  const [ videoModalOpen, setVideoModalOpen ] = useState( false )
  useChatbot()
  const { 'allStrapiCuradoria': { edges } } = data
  const [ strapiData ] = edges
  const kitPreviewImages =
    {
      'desktopImage': strapiData.node.KitPreviewImage.desktopImage?.localFile?.publicURL,
      'mobileImage': strapiData.node.KitPreviewImage.mobileImage?.localFile?.childImageSharp?.gatsbyImageData.images
    }
  const howItWorksData = { ...strapiData.node.HowItWorks, ...howItWorksCuradoriaDefaultData }
  const kitPreviewData = { ...kitPreviewImages, ...kitPreviewCuradoriaData }
  const nextKitData = { ...strapiData.node.NextKit, ...nextCuradoriaData }

  return (
    <>
      {( videoModalOpen &&
        <VideoModal
          onClose={ () => {
            setVideoModalOpen( false )
          } }
          source={ `${process.env.GATSBY_ASSETS_URL}/video_curadoria.mp4` }
        /> )}
      <ThemeProvider theme={ curadoriaTheme }>
        <ClubBanner
          playButtonOnClick={ () => {
            setVideoModalOpen( true )
          } }
          { ...clubBannerCuradoriaData }
        />
        <HowItWorks { ...howItWorksData } />
        <KitPreview { ...kitPreviewData } />
        <PreviousKits club="curadoria" />
        <NextKit { ...nextKitData } />
        <TAGTopics { ...curadoriaTopicsData } />
        <ClubSubscription { ...clubCuradoriaData } />
        <ClubTest />
        <Newsletter />
        <Footer />
      </ThemeProvider>
    </>
  )
}

Curadoria.propTypes = {
  'data': PropTypes.any.isRequired
}

export default Curadoria

export const query = graphql` {
  allStrapiCuradoria(limit: 1, sort: {order: DESC, fields: strapiId}) {
    edges {
      node {
        HowItWorks {
          column {
            id
            subtitle
            title
          }
          title
        }
        KitPreviewImage {
          desktopImage {
            localFile {
              publicURL
            }
          }
          mobileImage {
            localFile {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
        }
        NextKit {
          title
          description
          items {
            id
            subtitle
            icon {
              url
              alternativeText
            }
          }
        }
      }
    }
  }
}

`
